import React from "react";
import { Box, Button, MenuItem, TextField } from "@mui/material";

const OPTIONS = [
  "Mes atual",
  "Ultimos 7 dias",
  "Ultimos 30 dias",
  "Ultimos 3 meses",
  "Ultimos 6 meses",
  "Ultimos 12 meses",
  "Anual",
  "Datas Especificas",
];

const addYearsToDateString = (dateString, years) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  date.setFullYear(date.getFullYear() + years);
  return date.toISOString().split("T")[0];
};

const FiltroAtendimentos = ({
  viewMode,
  onViewModeChange,
  dateFilter,
  onChange,
  selectedYear,
  onYearChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onApplyFilters,
  onClearFilters,
}) => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = 2023; year <= currentYear; year += 1) {
    years.push(year);
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5, gap: 1, flexWrap: "wrap" }}>
      <TextField
        select
        label="Visualizacao"
        value={viewMode}
        onChange={(event) => onViewModeChange(event.target.value)}
        variant="outlined"
        size="small"
        sx={{
          width: 140,
          bgcolor: "background.paper",
          borderRadius: 1,
          "& .MuiOutlinedInput-root": {
            color: "text.primary",
            borderRadius: 1.5,
            "& fieldset": {
              borderColor: "divider",
            },
            "&:hover fieldset": {
              borderColor: "#667eea",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#667eea",
            },
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#667eea",
            opacity: 1,
          },
          "& .MuiInputLabel-root": {
            color: "text.secondary",
          },
          "& .MuiSelect-icon": {
            color: "text.secondary",
          },
        }}
      >
        {["Dia", "Mes", "Ano"].map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        label="Filtrar por periodo"
        value={dateFilter}
        onChange={(event) => onChange(event.target.value)}
        variant="outlined"
        size="small"
        sx={{
          width: 160,
          bgcolor: "background.paper",
          borderRadius: 1,
          "& .MuiOutlinedInput-root": {
            color: "text.primary",
            borderRadius: 1.5,
            "& fieldset": {
              borderColor: "divider",
            },
            "&:hover fieldset": {
              borderColor: "#667eea",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#667eea",
            },
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#667eea",
            opacity: 1,
          },
          "& .MuiInputLabel-root": {
            color: "text.secondary",
          },
          "& .MuiSelect-icon": {
            color: "text.secondary",
          },
        }}
      >
        {OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
      {dateFilter === "Anual" && (
        <TextField
          select
          label="Ano"
          value={selectedYear}
          onChange={(event) => {
            if (onYearChange) {
              onYearChange(event.target.value);
            }
          }}
          variant="outlined"
          size="small"
          sx={{
            width: 120,
            bgcolor: "background.paper",
            borderRadius: 1,
            "& .MuiOutlinedInput-root": {
              color: "text.primary",
              borderRadius: 1.5,
              "& fieldset": {
                borderColor: "divider",
              },
              "&:hover fieldset": {
                borderColor: "#667eea",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#667eea",
              },
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#667eea",
              opacity: 1,
            },
            "& .MuiInputLabel-root": {
              color: "text.secondary",
            },
            "& .MuiSelect-icon": {
              color: "text.secondary",
            },
          }}
        >
          <MenuItem value="">Selecione</MenuItem>
          {years.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </TextField>
      )}
      {dateFilter === "Datas Especificas" && (
        <>
          <TextField
            type="date"
            label="Data de inicio"
            value={startDate}
            onChange={(event) => onStartDateChange(event.target.value)}
            variant="outlined"
            size="small"
            error={startDate && endDate && startDate > endDate}
            helperText={
              startDate && endDate && startDate > endDate
                ? "Data de inicio nao pode ser posterior a data de fim"
                : ""
            }
            inputProps={{
              max: endDate || undefined,
              ...(endDate && { min: addYearsToDateString(endDate, -1) }),
            }}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              width: 145,
              bgcolor: "background.paper",
              borderRadius: 1,
              "& .MuiOutlinedInput-root": {
                color: "text.primary",
                borderRadius: 1.5,
                "& fieldset": {
                  borderColor: "divider",
                },
                "&:hover fieldset": {
                  borderColor: "#667eea",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#667eea",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#667eea",
                opacity: 1,
              },
              "& .MuiInputLabel-root": {
                color: "text.secondary",
              },
            }}
          />
          <TextField
            type="date"
            label="Data de fim"
            value={endDate}
            onChange={(event) => onEndDateChange(event.target.value)}
            variant="outlined"
            size="small"
            error={startDate && endDate && endDate < startDate}
            helperText={
              startDate && endDate && endDate < startDate
                ? "Data de fim nao pode ser anterior a data de inicio"
                : ""
            }
            inputProps={{
              min: startDate || undefined,
              ...(startDate && { max: addYearsToDateString(startDate, 1) }),
            }}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              width: 145,
              bgcolor: "background.paper",
              borderRadius: 1,
              "& .MuiOutlinedInput-root": {
                color: "text.primary",
                borderRadius: 1.5,
                "& fieldset": {
                  borderColor: "divider",
                },
                "&:hover fieldset": {
                  borderColor: "#667eea",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#667eea",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#667eea",
                opacity: 1,
              },
              "& .MuiInputLabel-root": {
                color: "text.secondary",
              },
            }}
          />
          <Button
            variant="contained"
            onClick={onApplyFilters}
            sx={{
              height: "40px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              fontWeight: 600,
              borderRadius: 1.5,
              textTransform: "none",
              fontSize: "0.875rem",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              width: 145,
              boxShadow: "0 2px 8px rgba(102, 126, 234, 0.2)",
              "&:hover": {
                background: "linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)",
                boxShadow: "0 6px 20px rgba(102, 126, 234, 0.3)",
                transform: "translateY(-1px)",
              },
            }}
          >
            Aplicar Filtros
          </Button>
        </>
      )}
      {onClearFilters && (
        <Button
          variant="outlined"
          onClick={onClearFilters}
          sx={{
            height: "40px",
            borderColor: "primary.main",
            color: "primary.main",
            bgcolor: (theme) => theme.palette.mode === "dark" ? "rgba(42, 133, 226, 0.12)" : "transparent",
            fontWeight: 600,
            borderRadius: 1.5,
            textTransform: "none",
            fontSize: "0.875rem",
            width: 145,
            "&:hover": {
              borderColor: "primary.light",
              backgroundColor: (theme) =>
                theme.palette.mode === "dark" ? "rgba(42, 133, 226, 0.22)" : "rgba(102, 126, 234, 0.08)",
            },
          }}
        >
          Limpar filtros
        </Button>
      )}
    </Box>
  );
};

export default FiltroAtendimentos;
